var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c("el-input", {
            ref: _vm.reference,
            attrs: { placeholder: _vm.prop.defaultValue },
            model: {
              value: _vm.currentValue,
              callback: function($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue"
            }
          })
        : _c("a", { attrs: { target: "_blank", href: _vm.urlFormatted } }, [
            _vm._v(" " + _vm._s(_vm.currentValue) + " ")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }